var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CCard',[_c('CCardBody',[_c('div',[(_vm.showProducts)?_c('MarketCartTable',{attrs:{"market":_vm.market}}):_vm._e()],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }